// const pick = (obj, flds = []) =>
//   Object.keys(obj).reduce((res, k) => (flds.includes(k) ? { ...res, [k]: obj[k] } : res), {});
export default function pickMuiTextFieldProps(props) {
  return props; // return pick(props, [
  //   'autoComplete',
  //   'autoFocus',
  //   'children',
  //   'defaultValue',
  //   'disabled',
  //   'error',
  //   'fullWidth',
  //   'helperText',
  //   'id',
  //   'InputLabelProps',
  //   'InputProps',
  //   'inputProps',
  //   'inputRef',
  //   'label',
  //   'margin',
  //   'multiline',
  //   'name',
  //   'onChange',
  //   'placeholder',
  //   'required',
  //   'rows',
  //   'rowsMax',
  //   'select',
  //   'SelectProps',
  //   'type',
  //   'value',
  //   // standard input handler
  //   'onClick',
  //   'onFocus',
  //   'onBlur',
  // ]);
}